import { render } from "./ResponseDateStats.vue?vue&type=template&id=9d87c4d2"
import script from "./ResponseDateStats.vue?vue&type=script&lang=js"
export * from "./ResponseDateStats.vue?vue&type=script&lang=js"
script.render = render

export default script